export default __webpack_public_path__ + "static/instant-payment-b55bc5dd661086c64222231777028454.webp";